export const thunkTypes = {
  SEARCH_CUSTOMERS: `compliance/searchCustomers`,
  GET_CASE: `compliance/getCase`,
  REVEAL_NATIONAL_ID: `compliance/revealNationalId`,
  RECORD_ACCESS: `compliance/recordAccess`,
  EXPORT_CASE: `compliance/exportCase`,
  REPLACE_CAPTURE: `compliance/replaceCapture`,
  RECORD_CUSTODY: `compliance/recordCustody`,
  REGISTER_INTERNAL_DELIVERY: `compliance/registerInternalDelivery`,
  UPDATE_ADDRESS: `compliance/updateAddress`,
  ADD_ADDRESS: `compliance/addAddress`,
  LIST_GEO_CATALOG: `compliance/listGeoCatalog`,
};
